export default __webpack_public_path__ + "static/media/OrangeDot.74da508e.svg";